import clsx from 'clsx';

export const variants = {
	// TODO Work with UX to migrate old variants across to new variants
	display1: 'h1',
	display2: 'h1',
	display3: 'h1',
	display4: 'h1',
	main: 'h1',
	mainTitleSmall: 'h1',
	mainTitleSmallBold: 'h1',
	mainTitleExtraSmallBold: 'h1',
	title1: 'h1',
	title2: 'h2',
	title3: 'h3',
	title4: 'h4',
	title5: 'h5',
	body: 'p',
	bodyBig: 'p',
	bodyExtraBig: 'p',
	bodyXl: 'p',
	bodySmall: 'p',
	bodySmallBold: 'p',
	link: 'p',

	// New typographic scale variants
	display_1: 'h1',
	display_2: 'h1',
	display_3: 'h1',
	heading_1_regular: 'h1',
	heading_1_medium: 'h1',
	heading_1_semibold: 'h1',
	heading_2_medium: 'h2',
	heading_2_semibold: 'h2',
	heading_3_medium: 'h3',
	heading_3_regular: 'h3',
	heading_3_semibold: 'h3',
	heading_3_bold: 'h3',
	heading_4_regular: 'h4',
	heading_4_medium: 'h4',
	heading_4_semibold: 'h4',
	heading_5_regular: 'h5',
	heading_5_medium: 'h5',
	heading_5_semibold: 'h5',
	body_lg_regular: 'p',
	body_lg_medium: 'p',
	body_lg_semibold: 'p',
	body_md_regular: 'p',
	body_md_medium: 'p',
	body_md_semibold: 'p',
	body_md_bold: 'p',
	body_sm_regular: 'p',
	body_sm_medium: 'p',
	body_sm_semibold: 'p',
} as const;

export const typographyVariants = {
	// TODO Work with UX to migrate old variants across to new variants
	display1: 'text-2xl xl:text-3xl font-bold',
	display2: 'text-xl md:text-2xl font-bold',
	display3: 'text-2xl font-bold',
	display4: 'text-xl font-bold',
	main: 'text-xl',
	mainTitleSmall: 'text-md',
	mainTitleSmallBold: 'text-md font-semibold',
	mainTitleExtraSmallBold: 'text-base font-semibold',
	title1: 'text-xl font-bold',
	title2: 'text-lg',
	title3: 'text-lg',
	title4: 'text-md font-semibold',
	title5: 'text-md font-bold md:text-[32px]',
	bodyBig: 'text-md',
	bodyXl: 'text-xl',
	bodyExtraBig: 'text-lg',
	body: 'text-base',
	bodySmall: 'text-sm',
	bodySmallBold: 'text-sm font-semibold',
	link: 'text-base text-primaryBrand cursor-pointer',

	// New typographic scale variants
	display_1: 'text-display-1 font-bold',
	display_2: 'text-48 font-medium',
	display_3: 'text-display-3 font-normal',
	heading_1_regular: 'text-heading-1 font-normal',
	heading_1_medium: 'text-heading-1 font-medium',
	heading_1_semibold: 'text-heading-1 font-semibold',
	heading_2_medium: 'text-heading-2 font-medium',
	heading_2_semibold: 'text-heading-2 font-semibold',
	heading_3_regular: 'text-heading-3 font-normal',
	heading_3_medium: 'text-heading-3 font-medium',
	heading_3_semibold: 'text-heading-3 font-semibold',
	heading_3_bold: 'text-heading-3 font-bold',
	heading_4_regular: 'text-heading-4 font-normal',
	heading_4_medium: 'text-heading-4 font-medium',
	heading_4_semibold: 'text-heading-4 font-semibold',
	heading_5_regular: 'text-heading-5 font-normal',
	heading_5_medium: 'text-heading-5 font-medium',
	heading_5_semibold: 'text-heading-5 font-semibold',
	body_lg_regular: 'text-body-lg font-normal',
	body_lg_medium: 'text-body-lg font-medium',
	body_lg_semibold: 'text-body-lg font-semibold',
	body_md_regular: 'text-body-md font-normal',
	body_md_semibold: 'text-body-md font-semibold',
	body_md_medium: 'text-body-md font-medium',
	body_md_bold: 'text-body-md font-bold',
	body_sm_regular: 'text-body-sm font-regular',
	body_sm_medium: 'text-body-sm font-medium',
	body_sm_semibold: 'text-body-sm font-semibold',
};

export type TypographyProps = {
	variant?: keyof typeof variants;
	className?: string;
	dataTestId?: string;
	children: React.ReactNode | string;
};

export const Typography = ({
	variant = 'body',
	className,
	children,
	dataTestId,
}: TypographyProps) => {
	const Component = variants[variant];
	const typographyStyles = typographyVariants[variant];

	return (
		<Component
			className={clsx('font-sans', typographyStyles, className)}
			data-test-id={dataTestId}
		>
			{children}
		</Component>
	);
};
